<template>
  <v-dialog v-model="dialog" width="580px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>SỬA ĐIỂM DỪNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <div class="pa-6">
        <BusStopForm class="mt-6" ref="form" :busStopData="busStop" />
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined class="ma-2" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BusStopForm from '@/components/basic/form/bus/BusStopForm.vue'

export default {
  components: {
    BusStopForm
  },
  props: {
    state: Boolean,
    busStop: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {},
  methods: {
    ...mapActions('busDetail', ['updateBusStop']),
    async save() {
      if (!this.$refs.form.validate()) return
      this.$loading.active = true

      const formData = this.$refs.form.getData()
      await this.updateBusStop({
        id: this.busStop.id,
        ...formData
      })
      this.dialog = false
      this.$loading.active = false
    },
    cancel() {
      this.$refs.form.resetDefault()
      this.dialog = false
    }
  },

  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
